import { Adapter as o } from "../../../../../adapter.js";
import { ShopSessionShopModel as r } from "./shop.model.js";
class t extends o {
  adapt(e) {
    return new r({
      id: e.id,
      url: e.url,
      token: e.token
    });
  }
  serialize(e) {
  }
}
export {
  t as ShopSessionShopAdapter
};
//# sourceMappingURL=shop.adapter.js.map
